import React from "react";
import { Modal, Form, Row, Col, Button, Select, Avatar } from "antd";
import { MembreTacheService } from "../../services/MembreTacheService";
import Toast from "../../helpers/Toast";
import PropTypes from "prop-types";
import { catchError } from "../../services/DaoService";
import CustomFormItem from "../utils/form/CustomFormItem";
import style from "./MembreTacheCreateForm.module.scss";
import UserService from "../../services/UserService";

const MembreTacheCreateForm = ({ visible, onCreate, onCancel, tache }) => {
    const [form] = Form.useForm();
    const [creating, setCreating] = React.useState(false);
    const [validationErrors, setValidationErrors] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const [users, setUsers] = React.useState([]);

    const renderUserOption = (user) => (
        <div className={style.userOption}>
            <Avatar
                src={user.avatar}
                alt={user.name}
                className={style.userAvatar}
            >
                {user.name?.slice(0, 2)?.toUpperCase()}
            </Avatar>
            <span>{user.name}</span>
        </div>
    );

    React.useEffect(() => {
        setLoading(true);
        Promise.all([
            UserService.getInstance().all(),
        ]).then(([usersResponse]) => {
            setUsers(usersResponse.data);
        }).catch(catchError)
            .finally(() => {
                setLoading(false);
            });
    }, []);


    const handleSave = () => {
        setCreating(true);
        form
            .validateFields()
            .then((values) => {
                values.tache_id = tache.id;
                MembreTacheService.getInstance()
                    .create(values)
                    .then((response) => {
                        Toast.success(response.message);
                        form.resetFields();
                        onCreate(response.data);
                        onCancel?.();
                    })
                    .catch((error) => {
                        const errors = error.response.data;
                        if (errors.validation && Object.keys(errors?.errors).length) {
                            setValidationErrors(errors.errors);
                        } else {
                            catchError(error);
                        }
                    })
                    .finally(() => {
                        setCreating(false);
                    });
            })
            .catch(() => {
                setCreating(false);
            });
    };

    return (
        <Modal
            width={620}
            open={visible}
            onCancel={onCancel}
            title="Ajouter un collaborateur à la tâche"
            className={style.memberModal}
            centered
            destroyOnClose
            footer={
                <div className={style.actionFooter}>
                    <Button
                        key="cancel"
                        onClick={onCancel}
                        className={style.secondaryButton}
                    >
                        Annuler
                    </Button>
                    <Button
                        key="save"
                        type="primary"
                        loading={creating}
                        onClick={() => handleSave(false)}
                        className={style.primaryButton}
                    >
                        Ajouter
                    </Button>
                </div>
            }
        >
            <div className={style.formSurface}>
                <Form
                    layout="vertical"
                    form={form}
                    name="createMembreTacheForm"
                    initialValues={{
                    }}
                >
                    <Row gutter={24}>
                        <Col xs={24} md={24} lg={24}>
                            <CustomFormItem
                                label="Collaborateurs"
                                name="user_ids"
                                rules={[{ required: true, message: "Veuillez sélectionner les collaborateurs" }]}
                                validationErrors={validationErrors}
                                setValidationErrors={setValidationErrors}
                            >
                                <Select
                                    size="large"
                                    showSearch
                                    optionFilterProp="name"
                                    loading={loading}
                                    mode="multiple"
                                    allowClear
                                    placeholder="Sélectionner des collaborateurs"
                                    maxTagCount="responsive"
                                    listHeight={280}
                                    popupClassName={style.memberSelectPopup}
                                    className={style.memberSelect}
                                    options={users.map((user) => ({
                                        value: user.id,
                                        label: renderUserOption(user),
                                        name: user.name
                                    }))}
                                />
                            </CustomFormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
        </Modal>
    );
};

export default MembreTacheCreateForm;

MembreTacheCreateForm.propTypes = {
    visible: PropTypes.bool,
    onCreate: PropTypes.func,
    onCancel: PropTypes.func,
    tache: PropTypes.object.isRequired,
};
